
export enum Stage {
  Local = 'local',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
export const stage: Stage =
  (window as { __limberStage?: Stage }).__limberStage || Stage.Local;

export const auth0Domain = 'stry.auth0.com';
export const auth0ClientId = {
  [Stage.Local]: '0OwaiTW7MVqU2JdTLNqa7zcNLITiyB8U',
  [Stage.Development]: '0OwaiTW7MVqU2JdTLNqa7zcNLITiyB8U',
  [Stage.Staging]: 'RtRuvt1jBxxy4bFD1KIQzHBL55JgZOds',
  [Stage.Production]: 'nxE4s1ChyOfvxQ16HPvk3G95jIhqOaGj',
}[stage];
export const auth0Audience = {
  [Stage.Local]: 'https://dev-admin-api.limberhealth.com/',
  [Stage.Development]: 'https://dev-admin-api.limberhealth.com/',
  [Stage.Staging]: 'https://stage-admin-api.limberhealth.com/',
  [Stage.Production]: 'https://admin-api.limberhealth.com/',
}[stage];
